import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl, fitPreviewToContainer, getVerified,baseFake, formatNumber, adaptHeightOnWidget, minutesToNextHour, isNotEmpty, RGB_2_ARRAY, isDesktop } from '../../lib/ep.js';
import { size as _size, isEqual as _isEqual } from 'lodash';
import { Howl } from 'howler';
import QRCode from 'qrcode.react';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import DigitImage from '../builder/DigitImage';
import TimeCounterPerform from '../builder/TimeCounterPerform.js';
import Loader from '../builder/Loader';
import ToggleButton from '../builder/ToggleButton';

import BestScore from '../svg/BestScore';

import PuzzleCanvas from './PuzzleCanvas.js';
import WordSearchCanvas from './WordSearchCanvas';
import MemoryCanvas from './MemoryCanvas.js';
import MatchCanvas from './MatchCanvas';
import MineSweeperCanvas from './MineSweeperCanvas';
import NextActionButton from './NextActionButton';
import RevealCanvas from './RevealCanvas';
import SearchCanvas from './SearchCanvas';
import LeveledHTMLText from '../front/helpers/LeveledHTMLText.js';
import EarnedPointsMessage from '../front/loyalty/EarnedPointsMessage.js';

const audio_files_path = `//wlcdn.cstmapp.com/sounds/`;

const ScoreResumee = (props) => {
	//const pr = props.participate_result || false;
	const pr = props.participate_result || { ranking:10 };

	const is_multiparticipation = (props.multiparticipation != undefined) ? props.multiparticipation : false;
	const has_ranking = (props.has_ranking != undefined) ? props.has_ranking : false;

	const stage = props?.stage?.Stage ?? props?.stage;

	const link = (props.stage == undefined) ? '/entries/' + props.promo_id : `/entries/${props.promo_id}/#s:${stage.id}`;

	return (
		<div style={{width:'100%', padding:'0 1.5em'}}>
			{(is_multiparticipation && pr != undefined && pr.ranking != undefined && has_ranking) && (
				<div class="position_in_ranking">
					<p><FormattedMessage id="You are in position {pos} in the {ranking}" values={{pos:<strong>{pr.ranking}</strong>, ranking:<ActionLink _class={{other:'original_color_item'}} _href={link}>Ranking</ActionLink>}} /></p>
				</div>
			)}

			<div class="game_resumee">
				<p>{props.title}:</p>
				<ul>
					{props.scoring_data.map((score, s) => {
						return (
							<li key={s}>
								<span>{score.label}:</span>
								<span>{score.value}</span>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
}

const AnimatedResultIcon = (props) => {
	const is_multiparticipation = (props.multiparticipation != undefined) ? props.multiparticipation : false;

	if(is_multiparticipation && props.participate_result != undefined && props.participate_result.best != undefined && props.participate_result.best) {
		return (
			<BestScore custom_success_color={props.custom_success_color} />
		)
	}

	return (
		<div class="icon_container"><div class="icon ep-thumbs-up-empty"></div></div>
	)
}

class GameWrapper extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			attempts:[],
			countdown_to_start:3,
			//display_instructions:null,
			display_hint:false,
			error_type:false,
			full_loaded:false,
			game_fully_loaded:false,
			game_solved:null,
			game_started:false,
			game_valid:true,
			game_verifying:false,
			game_with_countdown:true,
			hits:0,
			next_participation:null,
			retries:null,
			prize:null,
			options:(props.options != undefined) ? props.options : {},
			time_bonus:0,
			to_reset:false,
			flagger:false,
			num_flags:-1,
			show_game_after_end:false,
			action_init:false,
			muted:false,
		};

		this.displayed_ready_msg = false;

		this.num_container_tries = 0;
		this.points_per_hit = (this.props.options.type != 10) ? 100 : 10;
		this.points_per_extra_second = 10;
		this.stageRef = null;

		this.is_builder = (props.is_builder != undefined) ? props.is_builder : false;
		this.is_desktop = (isDesktop()) ? true : false;

		this.game_size;

		this.sound_error = new Howl({
			src:[`${audio_files_path}error_backflip.mp3?v=1.1`],
		});
		this.sound_success = new Howl({
			src:[`${audio_files_path}success.mp3?v=1.1`],
		});
		this.sound_selecting = new Howl({
			src:[`${audio_files_path}bubbles.mp3?v=1.1`],
			loop:true,
		});
		this.sound_flag = new Howl({
			src:[`${audio_files_path}flag.mp3?v=1.1`],
		});
		this.sound_flip = new Howl({
			src:[`${audio_files_path}card_flip.mp3?v=1.1`],
		});
		this.sound_move_in = new Howl({
			src:[`${audio_files_path}move_in.mp3?v=1.1`],
		});
		this.sound_move_out = new Howl({
			src:[`${audio_files_path}move_out.mp3?v=1.1`],
		});
		this.sound_end_ok = new Howl({
			src:[`${audio_files_path}applause.mp3?v=1.1`],
		});
		this.sound_end_ko = new Howl({
			src:[`${audio_files_path}fail.mp3?v=1.1`],
		});
		this.sound_unplug = new Howl({
			src:[`${audio_files_path}unplug.mp3?v=1.1`],
		});

		this.in_widget_fb = false;
		fbEnsureInit(() => {
			FB.Canvas.getPageInfo((response) => {
				this.in_widget_fb = true;
			});
		})

		var ref;
		switch(this.props.options.type) {
			case '4':
				ref = "puzzle" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '5':
				ref = "wordsearch" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '6':
				ref = "memory" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '7':
				ref = "search" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
		}
		this.name_cookie_time = ref+'_'+this.props.options.promotion_id;

		this.is_test = this.props.is_test != undefined ? this.props.is_test : false;
		window.handleGame = this;
		this.interval_countdown;
	}

	successPlay() {
		this.sound_end_ok.play();
	}

	gameOverPlay() {
		this.sound_end_ko.play();
	}

	componentWillReceiveProps(props) {
		if(!_isEqual(props.options, this.state.options)) {
			this.state.options = props.options;
			this.setState({ ...this.state });
		}
	}

	continueGame = (e) => {
		if(this.submitting != undefined && this.submitting) return;
		this.submitting = true;

		if(this.state.participate_result != undefined && this.state.participate_result.url != undefined) {
			window.location.href = this.state.participate_result.url;
			return;
		}

		if(this.props.on_continue != undefined) this.props.on_continue();
	}

	getContainerSize() {
		//const main_container = $('.gui_game_container');
		//const main_container = $('.canvas_content');	// commented to review widgets (there the canvas is bigger than the container) 
		const main_container = $('.game_container');
		var sizes = {
			w:0,
			h:0,
		};

		if(this.num_container_tries < 2) {
			if(main_container.width() != undefined && main_container.width() > 200) {
				sizes = {
					w:main_container.width() - 2,
					h:main_container.height() - 2,
				};
			} else {
				const t = setTimeout(() => {
					this.num_container_tries++;
					this.getContainerSize();
				}, 500);
			}
		} else {
			sizes = {
				w:window.innerWidth,
				h:window.innerHeight,
			};
		}

		//return sizes;
		return {
			w:Math.max(300, sizes.w),
			h:Math.max(300, sizes.h),
		};
	}

	calcContainerSize(cb) {
		var optimized_height_for_widget = (window.parent_location_w != undefined && window.parent_location_h != undefined) ? (Math.min(window.parent_location_w, window.parent_location_h) + 70) : 700;
		adaptHeightOnWidget(optimized_height_for_widget);

		const t = setTimeout(() => {
			const sizes = this.getContainerSize();

			if(sizes.w > 0 && sizes.h > 0) {
				this.game_size = Math.min(sizes.w, sizes.h);

				if(cb != undefined) cb(this.game_size);
				if(this.state.display_instructions) {
					this.state.display_instructions = undefined;
					this.setState({...this.state});
				}

				this.start_game_after_load();
				this.state.game_started = true;
				this.state.full_loaded = true;

				this.setState({...this.state});
				fitPreviewToContainer();
			} else {
				this.calcContainerSize(cb);
			}
		}, 300);
	}

	canvasToBuilder(options) {
		if(this.props.canvasToBuilder != undefined) this.props.canvasToBuilder(options);
	}

	getTime = (solved, data) => {
		var time,
			ref,
			game_valid;

		if(data == undefined && this.stageRef != undefined && this.stageRef.refs != undefined && this.stageRef.refs['stage'] != undefined) {
			data = {img:this.stageRef.refs['stage'].toDataURL()};
		}

		if(data != undefined)delete data.img;

		if(this.state.game_solved != null) return;

		let time_stopped_after_end_game = 0;
		const options = this.props.options;
		switch(options.type) {
			case '4':
				ref = "puzzle" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '5':
				ref = "wordsearch" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '6':
				ref = "memory" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '7':
				ref = "search" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '8':
				ref = "match" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '9':
				ref = "reveal" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				break;
			case '10':
				ref = "minesweeper" + ((this.props.external_reference != undefined) ? this.props.external_reference : '');
				time_stopped_after_end_game = 3500;
				break;
		}


		if(time_stopped_after_end_game>0){
			this.setState({show_game_after_end:true});
			setTimeout(() => {
				this.setState({show_game_after_end:false});
			},time_stopped_after_end_game);
		}


		if(this.state.full_loaded) {

			if(window[ref] != undefined) time = window[ref].getTimeUp();

			if(this.the_timer) {
				time = this.the_timer.getElapsedAndStop();
				time = time.current / 1000;

			}

			setCookie(this.name_cookie_time, 0, -1);//clear the cookie

			this.state.time_bonus = time;
			if(options.config.time_seconds != undefined && time>options.config.time_seconds){
				time = options.config.time_seconds;
			}

			solved = (solved != undefined) ? solved : false;
			game_valid = true;

			var mode_test = this.is_builder || this.is_test ? true : false;

			const t = setTimeout(() => {
				//if(window['game_time_down'] != undefined) window['game_time_down'].getTimeUp();
				this.the_timer_down.getElapsedAndStop();
				if(this.props.onSolve != undefined) {
					const error_type = this.props.onSolve(time, this.state.hits, _size(this.state.attempts), solved ,data);
					this.setState({ error_type:error_type });
				}
			}, 500);
			this.resultAction(mode_test,solved,time,data);
		}
		//}, time_wait);
	}

	resultAction(mode_test, solved, time, data) {
		if(window['game_time_down'] != undefined) window['game_time_down'].getTimeUp();

		if(mode_test) {
			(solved) ? this.successPlay() : this.gameOverPlay();
			this.setState({ game_solved:solved });
			return;
		}
		
		this.setState({ game_solved:solved, game_verifying:true });

		var delay = 2;	// secs
		if(solved) {
			this.successPlay();
		} else {
			this.gameOverPlay();
			delay = 0.8;
		}

		const hash = this.state.hash != undefined ? this.state.hash : this.props.gp_hash;

		const options = this.props.options;
		var send_data = {};
			send_data.page = 'quizquestion_'+options.id;
			send_data.type = 'gameplay';
			solved = (data.error_type!=undefined && data.error_type == 'fail') ? 'ko' : solved;
			send_data.info = baseFake(getVerified({time:time,timegame:options.config.time_seconds,attempts:_size(this.state.attempts),solved:solved,hash:hash,has_countdown:this.state.game_with_countdown}));

		$.post(`/promotions/action/${options.promotion_id}`, send_data, (json) => {
			var game_valid = true;
			const t = setTimeout(() => {
				if(json.status == 0) game_valid = false;

				if(solved && !game_valid) this.gameOverPlay();

				if(this.props.onSolve != undefined && game_valid) {
					data.gp_hash = hash;
					const error_type = this.props.onSolve(time, this.state.hits, _size(this.state.attempts), solved ,data);
					this.setState({ error_type:error_type });
				}

				if(this.props.multiparticipation && this.props.on_continue != undefined && game_valid) {
					this.props.on_continue(null, (res) => {
						if(res.status!==0){
							this.state.participate_result = res;
							if (this.state.participate_result?.loyalty != undefined){
								this.state.participate_result.loyalty.token = window.loyalty_tokens?.tokens[this.state.participate_result?.loyalty.token_id]
								window?.menu_ref?.getWrappedInstance().setTokens({[this.state.participate_result?.loyalty.token_id]:this.state.participate_result?.loyalty.total});
							}
							if(res.retries != undefined) this.state.retries = res.retries;
							if(res.prize != undefined) this.state.prize = res.prize;
							if(res.next_participation != undefined) {
								var next_participation = res.next_participation;
								if(next_participation !== false && next_participation !== true) {
									if (this.props.stage.Stage.participation_frequency == 'hour') {
										this.state.next_participation = minutesToNextHour(next_participation);
									}
									else {
										this.state.next_participation = moment.tz().to(moment.tz(next_participation, 'Europe/Madrid'));
									}
								} else {
									this.state.next_participation = next_participation;
								}
							}
						}else{
							game_valid = false;
						}
						this.state.game_verifying = false;
						this.state.game_valid = game_valid;
						
						this.setState({...this.state});
					});
				} else {
					this.state.game_verifying = false;
					this.state.game_valid = game_valid;
					this.setState({...this.state});
				}
			}, (delay * 1000 - 500));
		}, 'json');
	}

	addAttempt(attempt, is_solved) {
		if(this.is_builder) return;
		const config = this.props.options.config;
		const attempts = [...this.state.attempts,attempt];

		if(config.attempts_count_option != undefined && config.attempts_count_option) {
			const total_attempts = (config.attempts != undefined) ? config.attempts : false;
			if(total_attempts == attempts.length && !is_solved) this.getTime(false);
		}
		this.setState({attempts});
	}

	setNumFlags(num_flags) {
		this.setState({num_flags:num_flags});
	}

	addNewHit() {
		this.setState({hits:this.state.hits+1});
	}

	restartMulti(cb) {
		if (this.props.canPlayAgain == undefined) {
			this.restartGame(cb);
			return;
		}

		this.props.canPlayAgain(() => {
			this.restartGame(cb);
		});
	}

	restartGame(cb) {
		//window.location.reload();
		//return;
		const options = this.props.options;
		this.setState({
			attempts:[],
			full_loaded:false,
			game_fully_loaded:false,
			game_solved:null,
			game_started:false,
			game_valid:true,
			game_verifying:false,
			game_with_countdown:true,
			hits:0,
			options:options,
			to_reset:true,
		});

		var _ref = false;
		switch(options.type) {
			case '4':
				_ref = 'puzzle';
				break;
			case '5':
				_ref = 'wordsearch';
				break;
			case '6':
				_ref = 'memory';
				break;
			case '7':
				_ref = 'search';
				break;
			case '8':
				_ref = 'match';
				break;
			case '9':
				_ref = 'reveal';
				break;
			case '10':
				_ref = 'minesweeper';
				break;
		}
		_ref += (this.props.external_reference != undefined) ? this.props.external_reference : '';

		if(window[_ref] != undefined)window[_ref].restartTime(0);//Restart to 0
		if(window['game_time_down'] != undefined) window['game_time_down'].restartTime(options.config.time_seconds);

		//this.calcContainerSize();
		const t = setTimeout(() => {
			this.start_game_after_load();

			this.state.game_started = true;
			this.state.full_loaded = true;
			this.state.to_reset = false;
			this.state.game_with_countdown = false;

			this.setState({...this.state});

			this.setInitGame();
			if(cb != undefined) cb();
		}, 200);

		if(this.props.resetQuiz != undefined) this.props.resetQuiz();
	}

	getBonusPerTime() {
		var points = 0;

		var remaining_seconds = this.state.options.config.time_seconds - this.state.time_bonus;
		remaining_seconds = remaining_seconds > 0 ? remaining_seconds : 0;
		points += remaining_seconds * this.points_per_extra_second;

		return formatNumber(points);
	}

	setInitGame(cb) {
		if(this.is_builder || this.is_test) return;

		adaptHeightOnWidget();

		const options = this.state.options;
		let data = {
			hash:this.props.gp_hash,
			has_countdown:this.state.game_with_countdown,
		};
		if (this.props.stage != undefined) {
			data.stage_id = this.props.stage.Stage.id;
		}
		const send_data = {
			info:baseFake(getVerified(data)),
			type:'gamestart',
		};
		$.post('/promotions/action/' + options.promotion_id, send_data, (res) => {
			this.setState({ hash:res.hash })
			if (cb != undefined) cb();
		},'json');
	}

	startCountdown() {
		if(!this.in_widget_fb) {
			if(this.state.countdown_to_start == 3) this.setInitGame(()=>{
				this.setState({action_init:true});
			});
			const countdown = this.state.countdown_to_start;
			const time_left = countdown - 1;
			if(countdown <= 0 || countdown > 3){
				clearInterval(this.interval_countdown);
			}else{
				this.setState({
					countdown_to_start:time_left,
					game_with_countdown:true,
				});
			}
		} else {
			clearInterval(this.interval_countdown);
			this.setState({
				countdown_to_start:0,
				game_with_countdown:false,
			});
			this.setInitGame();
		}
	}

	displayHint() {
		if(this.state.display_hint === false) {
			this.setState({ display_hint:2 });

			const t = setInterval(() => {
				this.state.display_hint -= 1;
				if(this.state.display_hint === 0) {
					clearInterval(t);
					this.state.display_hint = false;
				}
				this.setState({ display_hint:this.state.display_hint });
			}, 1000);
		}
	}

	start_game_after_load() {
		const config = this.state.options.config;
		const has_instructions = (config.instructions_img != undefined && config.instructions_img != '') ? true : false;

		if(has_instructions && !this.is_builder && this.state.display_instructions == undefined) {
			this.state.display_instructions = true;
		} else {
			if(!has_instructions) this.state.display_instructions = true;
			if(this.state.countdown_to_start > 0 && this.state.display_instructions) {
				this.interval_countdown = setInterval(() => {
					this.startCountdown();
				}, 1000);
			}
			this.state.game_fully_loaded = true;
			this.state.display_instructions = false;
		}

		this.setState({ ...this.state });
	}

	formatColorToDB(color) {
		const color_arr = RGB_2_ARRAY(color);
		if(_size(color_arr) < 1) return false;
		return color_arr[0] + "," + color_arr[1] + "," + color_arr[2];
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		/*const pm = (this.props.promotion != undefined) ? this.props.promotion : false;
		if(!pm) return null;*/
		const options = this.state.options;
		if(options.type == undefined) return null;

		const main_color = this.props?.main_color ?? '#2951CC';
		const theme = options?.config?.theme ?? 'light';
		const bg_color = options?.config?.bg_color ?? ((theme == 'light') ? 'rgba(255, 255, 255, 1)' : 'rgba(0, 0, 0, 1)');
		const text_color = options?.config?.text_color ?? ((theme == 'light') ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)');

		var Game = false;
		var game_props = {
			to_reset:this.state.to_reset,
			adaptToContainer:this.calcContainerSize.bind(this),
			canvasToBuilder:this.canvasToBuilder.bind(this),
			theme:theme,
			bg_color:bg_color,
			text_color:text_color,
			instructions_img:(options.config.full_instructions_img != undefined) ? options.config.full_instructions_img : false,
			is_builder:this.is_builder,
			display_legend:(options.config.display_legend != undefined) ? options.config.display_legend : true,
			main_color:main_color,
			color_ok:(options.config.color_ok != undefined) ? this.formatColorToDB(options.config.color_ok) : '120, 195, 0',
			color_ko:(options.config.color_ko != undefined) ? this.formatColorToDB(options.config.color_ko) : '215, 35, 60',
			sound_fx:{
				error:this.sound_error,
				success:this.sound_success,
				selecting:this.sound_selecting,
				flip:this.sound_flip,
				flag:this.sound_flag,
				move_in:this.sound_move_in,
				move_out:this.sound_move_out,
				unplug:this.sound_unplug,
			},
		};

		var _ref = false;
		var display_score_header = true;
		var has_hints = false;
		var force_score_on_end = false;
		switch(options.type) {
			case '4':
				_ref = 'puzzle';
				Game = PuzzleCanvas;
				display_score_header = false;
				has_hints = game_props.display_legend;

				game_props.image = (options.config.images != undefined) ? (options.config.images[0]?.full ?? false) : false;
				game_props.level = (options.config.level != undefined) ? options.config.level : false;
				break;
			case '5':
				_ref = 'wordsearch';
				Game = WordSearchCanvas;

				game_props.words = (options.config.words != undefined) ? options.config.words : [];
				game_props.stage = this.props.stage;
				game_props.level = (options.config.level != undefined) ? options.config.level : false;
				game_props.columns = (options.config.size != undefined) ? options.config.size : 10;
				game_props.charset_preset = (options.config.charset_preset != undefined) ? options.config.charset_preset : 'latin';
				game_props.custom_charset = (options.config.custom_charset != undefined) ? options.config.custom_charset : '';
				break;
			case '6':
				_ref = 'memory';
				Game = MemoryCanvas;

				game_props.image = (options.image != undefined) ? options.fullimage : false;

				var images = (options.config.images != undefined) ? options.config.images : [];
				game_props.images = [];
				images.map((img, index) => {
					game_props.images.push(img.full);
				});
				break;
			case '7':
				_ref = 'search';
				Game = SearchCanvas;

				game_props.attempts = (options.config.attempts != undefined) ? options.config.attempts : false;
				game_props.image = (options.config.images != undefined && options.config.images.length > 0) ? options.config.images[0].full : false;

				var areas = (options.config.areas != undefined) ? options.config.areas : [];
				game_props.areas = [];
				areas.map((position, index) => {
					game_props.areas.push(position);
				});
				break;
			case '8':
				_ref = 'match';
				Game = MatchCanvas;

				game_props.image = (options.image != undefined) ? options.fullimage : false;
				game_props.backflip1 = (options.config.backflip1 != undefined) ? options.config.full_backflip1 : false;
				game_props.backflip2 = (options.config.backflip2 != undefined) ? options.config.full_backflip2 : false;
				game_props.distribution_mode = (options.config.distribution_mode != undefined) ? options.config.distribution_mode : 'separation';
				game_props.display_cards_backfliped = (options.config.display_cards_backfliped != undefined) ? options.config.display_cards_backfliped : true;

				var images = (options.config.images != undefined) ? options.config.images : [];
				game_props.images = [];
				images.map((img, index) => {
					game_props.images.push({ image:img.full, group:img.order, name:img.name });
				});
				break;
			case '9':
				_ref = 'reveal';
				Game = RevealCanvas;

				game_props.image = options.image != undefined ? options.fullimage : false;

				var images = (options.config.images != undefined) ? options.config.images : [];

				game_props.images = [];
				game_props.names = [];
				images.map((img, index) => {
					game_props.images.push(img.full);
					game_props.names.push(img.name);
				});
				game_props.level = (options.config.level != undefined) ? options.config.level : false;
				game_props.num_plays = options.config.num_plays != undefined ? options.config.num_plays : 1;
				game_props.words = (options.config.words != undefined) ? options.config.words : [];
				break;
			case '10':
				_ref = 'minesweeper';
				Game = MineSweeperCanvas;

				options.config.mines = (options.config.mines != undefined) ? options.config.mines : 1;
				game_props.columns = (options.config.size != undefined) ? options.config.size : options.config.columns;
				game_props.cell_color = (options.config.cell_color != undefined) ? this.formatColorToDB(options.config.cell_color) : 'rgba(0, 0, 0, 1)';
				game_props.grid = (options.config.grid != undefined) ? options.config.grid : false;
				game_props.mines = options.config.mines;
				game_props.mine_img = (options.config.mine_img != undefined) ? options.config.full_mine_img : false;
				game_props.flag_img = (options.config.flag_img != undefined) ? options.config.full_flag_img : false;
				game_props.setNumFlags = this.setNumFlags.bind(this);
				game_props.show_result = this.state.show_game_after_end;
				force_score_on_end = true;
				//game_props.flagger = this.state.flagger;
				break;
		}

		if(!Game || !_ref) return null;

		_ref += (this.props.external_reference != undefined) ? this.props.external_reference : '';

		if(options.type == 10) {
			options.config.attempts = (options.config.mines != undefined ) ? options.config.mines : options.config.min_mine;
			options.config.time_seconds = (options.config.time_seconds != undefined) ? options.config.time_seconds : 60;
		}
		const attempts_to_display = options.config.attempts - _size(this.state.attempts);

		//const allow_retry = (options.config.allow_retry != undefined && JSON.parse(options.config.allow_retry)) ? true : false;
		const disallow_complete = (options.config.disallow_complete != undefined && JSON.parse(options.config.disallow_complete)) ? true : false;
		const allow_retry = true;

		const score_per_hits = formatNumber(this.state.hits * this.points_per_hit);
		var score_bonus_time  = this.getBonusPerTime();
		if(!this.state.game_solved &&  !this.state.game_verifying && options.type == 10) {
			score_bonus_time = 0;
		}
		const scoring_data = [{
			label:i18n("score", 'ucfirst'),
			value:score_per_hits,
		}, {
			label:i18n("Bonus time"),
			value:score_bonus_time,
		}, {
			label:i18n("Total score"),
			value:formatNumber(parseFloat(score_per_hits) + parseFloat(score_bonus_time)),
		}];
		const countdown_ended = (this.state.countdown_to_start == 0) ? true : false;

		if(this.state.full_loaded && !countdown_ended && !this.is_builder && !this.displayed_ready_msg) {
			this.displayed_ready_msg = setTimeout(() => {
				const container_w = $('.game_landing').width() - 30;
				const text_el = $('.status_title');
				const text_w = text_el.width();

				if(text_w > container_w) text_el.css({ zoom:Math.min(1, container_w / text_w) });
			}, 10);
		}

		//get cookie time if it necessary
		const cookie_time = getCookie(this.name_cookie_time);
		var seconds_game = cookie_time ? ((options.config.time_seconds < cookie_time) ? 1 : cookie_time) : options.config.time_seconds;
		const display_play_button = (options.config.display_play_button != undefined) ? options.config.display_play_button : true;

		const forced_screen = (this.props.forced_screen != undefined) ? this.props.forced_screen : false;
		const display_instructions = ((!this.is_builder && this.state.display_instructions) || forced_screen == 'instructions') ? true : false;
		const display_success = (this.is_builder && forced_screen == 'success') ? true : false;
		const display_fail = (this.is_builder && forced_screen == 'fail') ? true : false;
		const display_fail_time = (this.is_builder && forced_screen == 'fail_time') ? true : false;
		const display_fail_game = (this.is_builder && forced_screen == 'fail_game') ? true : false;

		const custom_success_color = (options.config.color_success != undefined) ? options.config.color_success : false;
		const custom_fail_color = (options.config.color_fail != undefined) ? options.config.color_fail : false;
		const custom_fail_time_color = (options.config.color_fail_time != undefined) ? options.config.color_fail_time : false;
		const custom_fail_game_color = (options.config.color_fail_game != undefined) ? options.config.color_fail_game : false;
		const show_game_after_end = this.state.show_game_after_end;

		const silence = options.config?.silence ?? false;

		// we affect the global sound volume in case of muted ON:
		Howler.volume((this.state.muted || silence) ? 0 : 1);

		if(display_success && !show_game_after_end) {
			const fake_scoring_data = [{
				label:i18n("score", 'ucfirst'),
				value:formatNumber(300),
			}, {
				label:i18n("Bonus time"),
				value:formatNumber(52),
			}, {
				label:i18n("Total score"),
				value:formatNumber(352),
			}];

			return (
				<aside class="flex_col col_2 game_wrapper" style={{height:'100%'}}>
					<article class="main_contents_flex gui_game_main_container" style={{height:'100%'}}>
						<section class="gui_game_container" style={{height:'100%'}}>
							<div class={'game_result override_styles is_ok is_fullscreen relative_to_container' + ((custom_success_color) ? ' custom_color' : '')} style={(custom_success_color) ? { backgroundColor:custom_success_color } : null}>
								<div class="g">
									<AnimatedResultIcon
										scoring_data={fake_scoring_data}
										custom_success_color={custom_success_color}
										multiparticipation={this.props.multiparticipation}
									/>

									<LeveledHTMLText
										_class={{ other:'status_title' }}
									>
										{(isNotEmpty(options.config, 'game_end_message_ok')) ? options.config.game_end_message_ok.replace(/\n/g, '<br />') : `<h1>${i18n("Good job!")}</h1>`}
									</LeveledHTMLText>

									<EarnedPointsMessage
										loyalty={this.state?.participate_result?.loyalty}
										promotion={{Promotion:this.props.promotion}}
									/>

									<ScoreResumee
										title={i18n("Results")}
										stage={this.props.stage}
										scoring_data={fake_scoring_data}
										multiparticipation={this.props.multiparticipation}
										promo_id={this.props.options.promotion_id}
										has_ranking={this.props.has_ranking}
									/>
								</div>

								<NextActionButton
									custom_color={custom_success_color}
									multiparticipation={this.props.multiparticipation}
									status='ok'
									allow_retry={allow_retry}
									retries={this.state.retries}
									prize={this.state.prize}
									next_participation={this.state.next_participation}
									continueGame={this.continueGame}
									restartGame={() => this.restartMulti()}
									intl={this.props.intl}
									is_builder={this.is_builder}
								/>
							</div>
						</section>
					</article>
				</aside>
			)
		}

		if(display_fail  && !show_game_after_end) {
			const fake_scoring_data = [{
				label:i18n("score", 'ucfirst'),
				value:formatNumber(100),
			}, {
				label:i18n("Bonus time"),
				value:formatNumber(0),
			}, {
				label:i18n("Total score"),
				value:formatNumber(100),
			}];

			const fail_moves_msg = (isNotEmpty(options.config, 'game_end_message_ko')) ? options.config.game_end_message_ko.replace(/\n/g, '<br />') : `<h1>${i18n("You ran out of moves!")}</h1>`;

			return (
				<aside class="flex_col col_2 game_wrapper" style={{height:'100%'}}>
					<article class="main_contents_flex gui_game_main_container" style={{height:'100%'}}>
						<section class="gui_game_container" style={{height:'100%'}}>
							<div class={'game_result override_styles is_ko is_fullscreen relative_to_container' + ((custom_fail_color) ? ' custom_color' : '')} style={(custom_fail_color) ? { backgroundColor:custom_fail_color } : null}>
								<div class="g">
									<div class="icon_container"><div class="icon ep-delete-circle"></div></div>

									<LeveledHTMLText
										_class={{ other:'status_title' }}
									>
										{fail_moves_msg}
									</LeveledHTMLText>

									{(!this.is_builder) && (
										<ScoreResumee stage={this.props.stage} title={i18n("Results")} scoring_data={fake_scoring_data} multiparticipation={this.props.multiparticipation} promo_id={this.props.options.promotion_id} has_ranking={this.props.has_ranking} />
									)}
								</div>

								<NextActionButton
									multiparticipation={this.props.multiparticipation}
									custom_color={custom_fail_color}
									status='ko'
									allow_retry={true}
									retries={1}
									next_participation={this.state.next_participation}
									continueGame={this.continueGame}
									restartGame={() => this.restartMulti()}
									intl={this.props.intl}
									is_builder={this.is_builder}
								/>
							</div>
						</section>
					</article>
				</aside>
			)
		}

		if((display_fail_time || display_fail_game) && !show_game_after_end) {
			const fake_scoring_data = [
				{
					label:i18n("score", 'ucfirst'),
					value:formatNumber(200),
				},
				{
					label:i18n("Bonus time"),
					value:formatNumber(0),
				},
				{
					label:i18n("Total score"),
					value:formatNumber(200),
				},
			];

			let icon = 'ep-delete-circle';
			let color = custom_fail_time_color;
			let color_custom = (custom_fail_time_color) ? ' custom_color' : '';
			let style = (custom_fail_time_color) ? { backgroundColor:custom_fail_time_color } : null;
			let message = (isNotEmpty(options.config, 'game_end_message_ko_time')) ? options.config.game_end_message_ko_time : `<h1>${i18n("***Time's up!")}</h1>`;

			if(!display_fail_time) {
				icon = 'knk-reaction-sad';
				color = custom_fail_game_color;
				color_custom = (custom_fail_game_color) ? ' custom_color' : '';
				style = (custom_fail_game_color) ? { backgroundColor:custom_fail_game_color } : null;
				message = (isNotEmpty(options.config, 'game_end_message_ko_game')) ? options.config.game_end_message_ko_game : `<h1>${i18n("Oops")}</h1>`;
			}

			return (
				<aside class="flex_col col_2 game_wrapper" style={{height:'100%'}}>
					<article class="main_contents_flex gui_game_main_container" style={{height:'100%'}}>
						<section class="gui_game_container" style={{height:'100%'}}>
							<div class={'game_result override_styles is_ko is_fullscreen relative_to_container' + color_custom} style={style}>
								<div class="g">
									<div class="icon_container">
										<div class={`icon ${icon}`} />
									</div>

									<LeveledHTMLText
										_class={{ other:'status_title' }}
									>
										{message.replace(/\n/g, '<br />')}
									</LeveledHTMLText>

									{(!this.is_builder) && (
										<ScoreResumee
											stage={this.props.stage}
											title={i18n("Results")}
											scoring_data={fake_scoring_data}
											participate_result={(display_fail_game) ? this.state.participate_result : null}
											multiparticipation={this.props.multiparticipation}
											promo_id={this.props.options.promotion_id}
											has_ranking={this.props.has_ranking}
										/>
									)}
								</div>

								<NextActionButton
									multiparticipation={this.props.multiparticipation}
									custom_color={color}
									status='ko'
									allow_retry={true}
									login_type={this.props.promotion.login_type}
									retries={1}
									next_participation={this.state.next_participation}
									continueGame={this.continueGame}
									restartGame={() => this.restartMulti()}
									intl={this.props.intl}
									is_builder={this.is_builder}
								/>
							</div>
						</section>
					</article>
				</aside>
			)
		}

		return (
			<aside class="flex_col col_2 game_wrapper">
				<article class="main_contents_flex gui_game_main_container">
					{(this.props.title != undefined && this.props.title != "") && (
						<LeveledHTMLText
							_class={{ other:'game_title question_text' }}
						>{this.props.title}</LeveledHTMLText>
					)}

					{(this.state.game_fully_loaded || display_instructions) && (
						<div class="game_participation_info gui_main_text_color_on_bg">
							<div class="time_counter knk-timecounter">
								{(!countdown_ended || display_instructions) && (
									<TimeCounterPerform
										ref="faroltime_ref"
										external_reference="faroltime"
										format="m:s.d"
										simplified_decimals={true}
										display_if_zero={false}
										only_digit={false}
										in_text={false}
										full_labels={true}
										stopped={true}
										seconds={seconds_game}
										classes=''	// remove the "hasCountdown" class so it doesn't zoom the digits
									/>
								)}

								{(this.state.game_started && countdown_ended && !display_instructions) && (
									<TimeCounterPerform
										// ref="game_time_down_ref"
										ref={(ref)=>{this.the_timer_down=ref}}
										external_reference="game_time_down"
										format="m:s.d"
										simplified_decimals={true}
										display_if_zero={false}
										only_digit={false}
										in_text={false}
										full_labels={true}
										stopped={this.is_builder}
										seconds={options.config.time_seconds}
										count_up={false}
										onEnd={() => this.getTime(false)}
										classes=''	// remove the "hasCountdown" class so it doesn't zoom the digits
									/>
								)}
							</div>

							{(display_score_header) && (
								<div class="gui_total_points countdown_row knk-goal">
									<DigitImage only_digit={true} value={this.state.hits * this.points_per_hit} />
								</div>
							)}

							{(options.config.attempts_count_option) && (
								<div class="gui_total_attempts countdown_row knk-me">
									<DigitImage only_digit={true} value={attempts_to_display} />
								</div>
							)}

							{(this.state.num_flags>=0) && (
								<div class="knk-flag gui_total_attempts countdown_row">
									<DigitImage only_digit={true} value={this.state.num_flags} />
								</div>
							)}

							{(has_hints && countdown_ended && !display_instructions) && (
								<div class="game_hint_link in_top">
									{(this.state.display_hint === false) ? (
										<ActionLink _class={{other:'gui_main_text_color_on_bg gui_underlined_text'}} onClick={() => this.displayHint()}>Help</ActionLink>
									) : (
										<FormattedMessage id="Help will hide in {time}" values={{time:this.state.display_hint}} />
									)}
								</div>
							)}

							{((has_hints && display_instructions) || (has_hints && game_props.instructions_img && !countdown_ended)) && (
								<div class="game_hint_link in_top" />
							)}
						</div>
					)}

					<section class="gui_game_container">
						<Game
							stageInstance={(stage) => this.stageRef = stage}
							game_init={this.state.action_init || this.is_builder || this.is_test}
							onSolve={this.getTime}
							onHitResult={() => this.addNewHit()}
							onFireAttempt={this.addAttempt.bind(this)}
							display_hint={this.state.display_hint}
							{...game_props}
						/>

						{/* 2022-01-12: We added '|| true' in the following 'this.is_desktop' because it broke the layout in mobile */}
						{(display_instructions && !show_game_after_end) && (
							<div class={'gui_game_container game_preload is_fullscreen' + ((this.is_desktop || true) ? ' relative_to_container' : '')} onClick={() => this.start_game_after_load()}>
								{(game_props.instructions_img) ? (
									<div class="game_instructions_container" style={{backgroundImage:'url(' + game_props.instructions_img + ')'}}>
										<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" alt="" />
										{(display_play_button) && (
											<div class="floating_button is_bottom is_fullscreen relative_to_container">
												<div class="flex_button gui_big_button gui_flex_center gui_custom_color">
													<ActionButton
														_fullclass="original_color_item blackColor"
													>Start</ActionButton>
												</div>
											</div>
										)}
									</div>
								) : (
									<div class="game_instructions_container is_fullscreen relative_to_container gui_flex_align_center gui_flexbox_auto gui_flex_center">
										<p>{i18n("There is no instruction page")}.</p>
									</div>
								)}
							</div>
						)}

						{(this.state.game_fully_loaded && !countdown_ended && !this.is_builder && !this.in_widget_fb && !display_instructions  && !show_game_after_end) && (
							<div class="gui_pos_abs" style={{width:'100%', top:'0'}}>
								<img src={window.cdn_url + 'img/blank_1x1.png'} width="100%" alt="" />
								<div class={'is_fullscreen relative_to_container game_landing is_' + theme}>
									<div class="g">
										<h1 class="status_title">{i18n("Ready", 'uppercase')}</h1>

										<DigitImage
											force_center={true}
											only_digit={true}
											value={this.state.countdown_to_start}
										/>
									</div>
								</div>
							</div>
						)}

						{(this.state.game_verifying === true && this.state.game_solved) && (
							<div class={'game_result override_styles is_fullscreen is_verifying finished_ok' + ((this.is_desktop) ? ' relative_to_container' : '')}>
								<div class="whiteColor gui_withoutEvents">{i18n("Completed!")}</div>
							</div>
						)}
					</section>

					{(silence === false) && (
						<div class="game_config_controls">
							<ToggleButton
								squared={true}
								active={!this.state.muted}
								icon='ep-sound-on'
								icon_off='ep-sound-off'
								onClick={() => this.setState({ muted:!this.state.muted })}
							/>
						</div>
					)}

					{(this.state.game_verifying === true && !this.state.game_solved && !show_game_after_end) && (
						<div class={'game_result override_styles is_fullscreen is_verifying is_ko' + ((this.is_desktop) ? ' relative_to_container' : '')}>
							<div class="flex_button gui_big_button gui_flex_center gui_custom_color gui_withoutEvents">
								<ActionButton
									_fullclass="original_color_item inlined_flex_btn"
									autotranslate={false}
								>
									<span>{i18n("Verifying")}</span>

									<Loader color='var(--ep-red-color)' />
								</ActionButton>
							</div>
						</div>
					)}

					{(this.state.game_valid === false  && this.state.game_verifying === false && !show_game_after_end) && (
						<div class={'game_result override_styles is_sh is_fullscreen' + ((this.is_desktop) ? ' relative_to_container' : '')}>
							<div class="g">
								<div class="icon_container">
									<div class="icon ep-thumbs-down-empty" />
								</div>

								<LeveledHTMLText
									_class={{ other:'status_title' }}
								>
									{`<h1>${i18n("Invalid game")}</h1>`}
								</LeveledHTMLText>

								<div class="is_qr">
									<QRCode value={this.props.gp_hash} size={150} />
								</div>
							</div>
						</div>
					)}

					{(this.state.game_solved === true && this.state.game_valid === true && this.state.game_verifying === false && !show_game_after_end) && (
						<div class={'game_result override_styles is_ok is_fullscreen' + ((this.is_desktop) ? ' relative_to_container' : '') + ((custom_success_color) ? ' custom_color' : '')} style={(custom_success_color) ? { backgroundColor:custom_success_color } : null}>
							<div class="g">
								<AnimatedResultIcon
									scoring_data={scoring_data}
									participate_result={this.state.participate_result}
									custom_success_color={custom_success_color}
									multiparticipation={this.props.multiparticipation}
								/>

								<LeveledHTMLText
									_class={{ other:'status_title' }}
								>
									{(isNotEmpty(options.config, 'game_end_message_ok')) ? options.config.game_end_message_ok.replace(/\n/g, '<br />') : `<h1>${i18n("Good job!")}</h1>`}
								</LeveledHTMLText>

								<EarnedPointsMessage
									loyalty={this.state?.participate_result?.loyalty}
									promotion={{Promotion:this.props.promotion}}
									locale={this.props.locale}
								/>

								<ScoreResumee
									stage={this.props.stage}
									title={i18n("Results")}
									scoring_data={scoring_data}
									participate_result={this.state.participate_result}
									multiparticipation={this.props.multiparticipation}
									promo_id={this.props.options.promotion_id}
									has_ranking={this.props.has_ranking}
								/>
							</div>

							<NextActionButton
								login_type={this.props.promotion.login_type}
								multiparticipation={this.props.multiparticipation}
								custom_color={custom_success_color}
								status='ok'
								allow_retry={allow_retry}
								retries={this.state.retries}
								prize={this.state.prize}
								next_participation={this.state.next_participation}
								continueGame={this.continueGame}
								restartGame={() => this.restartMulti()}
								intl={this.props.intl}
								is_builder={this.is_builder}
							/>
						</div>
					)}

					{(this.state.game_solved === false && this.state.game_valid === true && this.state.game_verifying === false && this.state.error_type != 'attempts' && this.state.error_type != 'fail' && !show_game_after_end) && (
						<div class={'game_result override_styles is_ko is_fullscreen' + ((this.is_desktop) ? ' relative_to_container' : '') + ((custom_fail_time_color) ? ' custom_color' : '')} style={(custom_fail_time_color) ? { backgroundColor:custom_fail_time_color } : null}>
							<div class="g">
								<div class="icon_container">
									<div class="icon ep-delete-circle" />
								</div>

								<LeveledHTMLText
									_class={{ other:'status_title' }}
								>
									{isNotEmpty(options.config, 'game_end_message_ko_time') ? options.config.game_end_message_ko_time.replace(/\n/g, '<br />') : `<h1>${i18n("***Time's up!")}</h1>`}
								</LeveledHTMLText>

								{(!this.is_builder && (!allow_retry || force_score_on_end)) && (
									<ScoreResumee
										stage={this.props.stage}
										title={i18n("Results")}
										scoring_data={scoring_data}
										multiparticipation={this.props.multiparticipation}
										promo_id={this.props.options.promotion_id}
										has_ranking={this.props.has_ranking}
									/>
								)}
							</div>

							<NextActionButton
								login_type={this.props.promotion.login_type}
								multiparticipation={this.props.multiparticipation}
								custom_color={custom_fail_time_color}
								status='ko' allow_retry={allow_retry}
								disallow_complete={disallow_complete}
								retries={this.state.retries}
								prize={this.state.prize}
								next_participation={this.state.next_participation}
								continueGame={this.continueGame}
								restartGame={() => this.restartMulti()}
								intl={this.props.intl}
								is_builder={this.is_builder}
							/>
						</div>
					)}

					{(this.state.game_solved === false && this.state.game_valid === true && this.state.game_verifying === false && this.state.error_type == 'fail' && !show_game_after_end) && (
						<div class={'game_result override_styles is_ko is_fullscreen' + ((this.is_desktop) ? ' relative_to_container' : '') + ((custom_fail_game_color) ? ' custom_color' : '')} style={(custom_fail_game_color) ? { backgroundColor:custom_fail_game_color } : null}>
							<div class="g">
								<div class="icon_container">
									<div class="icon knk-reaction-sad" />
								</div>

								<LeveledHTMLText
									_class={{ other:'status_title' }}
								>
									{isNotEmpty(options.config, 'game_end_message_ko_game') ? options.config.game_end_message_ko_game.replace(/\n/g, '<br />') : `<h1>${i18n("Oops")}</h1>`}
								</LeveledHTMLText>

								{(!this.is_builder && (!allow_retry || force_score_on_end)) && (
									<ScoreResumee stage={this.props.stage} title={i18n("Results")} scoring_data={scoring_data} participate_result={this.state.participate_result} multiparticipation={this.props.multiparticipation} promo_id={this.props.options.promotion_id} has_ranking={this.props.has_ranking} />
								)}
							</div>

							<NextActionButton
								login_type={this.props.promotion.login_type}
								multiparticipation={this.props.multiparticipation}
								custom_color={custom_fail_time_color}
								status='ko'
								allow_retry={allow_retry}
								disallow_complete={disallow_complete}
								retries={this.state.retries}
								next_participation={this.state.next_participation}
								continueGame={this.continueGame}
								restartGame={() => this.restartMulti()}
								intl={this.props.intl}
								is_builder={this.is_builder}
							/>
						</div>
					)}

					{(this.state.game_solved === false && this.state.game_valid === true && this.state.game_verifying === false && this.state.error_type == 'attempts' && !show_game_after_end) && (
						<div class={'game_result override_styles is_ko is_fullscreen' + ((this.is_desktop) ? ' relative_to_container' : '') + ((custom_fail_color) ? ' custom_color' : '')} style={(custom_fail_color) ? { backgroundColor:custom_fail_color } : null}>
							<div class="g">
								<div class="icon_container">
									<div class="icon ep-delete-circle" />
								</div>

								<LeveledHTMLText
									_class={{ other:'status_title' }}
								>
									{isNotEmpty(options.config, 'game_end_message_ko') ? options.config.game_end_message_ko.replace(/\n/g, '<br />') : `<h1>${i18n("You ran out of moves!")}</h1>`}
								</LeveledHTMLText>

								{(!this.is_builder && (!allow_retry || force_score_on_end)) && (
									<ScoreResumee
										stage={this.props.stage}
										title={i18n("Results")}
										scoring_data={scoring_data}
										multiparticipation={this.props.multiparticipation}
										promo_id={this.props.options.promotion_id}
										has_ranking={this.props.has_ranking}
									/>
								)}
							</div>

							<NextActionButton
								login_type={this.props.promotion.login_type}
								multiparticipation={this.props.multiparticipation}
								custom_color={custom_fail_color}
								status='ko'
								allow_retry={allow_retry}
								disallow_complete={disallow_complete}
								retries={this.state.retries}
								next_participation={this.state.next_participation}
								continueGame={this.continueGame}
								restartGame={() => this.restartMulti()}
								intl={this.props.intl}
								is_builder={this.is_builder}
							/>
						</div>
					)}

					{(this.state.game_started && countdown_ended) && (
						<div class="gui_hide_this">
							<TimeCounterPerform
								ref={(ref)=>{this.the_timer=ref}}
								external_reference={_ref}
								format="m:s.d"
								only_digit={false}
								in_text={false}
								stopped={this.is_builder}
								full_labels={true}
								seconds={0}
								count_up={true}
							/>
						</div>
					)}
				</article>
			</aside>
		)
	}
}

export default injectIntl(GameWrapper);